export default "__VITE_ASSET__CpdOueos__"